import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'memberOrder' })
export class MemberOrderPipe implements PipeTransform {
    transform(index: number, gridSize: number): number {
        return Math.ceil((index + 1) / gridSize) * gridSize;
    }
}
